export const TER_CATEGORY_A = [
  {
    id: 1,
    grossIncomeMin: 0,
    grossIncomeMax: 5400000,
    taxRate: 0, // 0%
  },
  {
    id: 2,
    grossIncomeMin: 5400001,
    grossIncomeMax: 5650000,
    taxRate: 0.0025, // 0.25%
  },
  {
    id: 3,
    grossIncomeMin: 5650001,
    grossIncomeMax: 5950000,
    taxRate: 0.005, // 0.5%
  },
  {
    id: 4,
    grossIncomeMin: 5950001,
    grossIncomeMax: 6300000,
    taxRate: 0.0075, // 0.75%
  },
  {
    id: 5,
    grossIncomeMin: 6300001,
    grossIncomeMax: 6750000,
    taxRate: 0.01, // 1%
  },
  {
    id: 6,
    grossIncomeMin: 6750001,
    grossIncomeMax: 7500000,
    taxRate: 0.0125, // 1.25%
  },
  {
    id: 7,
    grossIncomeMin: 7500001,
    grossIncomeMax: 8550000,
    taxRate: 0.015, // 1.5%
  },
  {
    id: 8,
    grossIncomeMin: 8550001,
    grossIncomeMax: 9650000,
    taxRate: 0.0175, // 1.75%
  },
  {
    id: 9,
    grossIncomeMin: 9650001,
    grossIncomeMax: 10050000,
    taxRate: 0.02, // 2%
  },
  {
    id: 10,
    grossIncomeMin: 10050001,
    grossIncomeMax: 10350000,
    taxRate: 0.0225, // 2.25%
  },
  {
    id: 11,
    grossIncomeMin: 10350001,
    grossIncomeMax: 10700000,
    taxRate: 0.025, // 2.5%
  },
  {
    id: 12,
    grossIncomeMin: 10700001,
    grossIncomeMax: 11050000,
    taxRate: 0.03, // 3%
  },
  {
    id: 13,
    grossIncomeMin: 11050001,
    grossIncomeMax: 11600000,
    taxRate: 0.035, // 3.5%
  },
  {
    id: 14,
    grossIncomeMin: 11600001,
    grossIncomeMax: 12500000,
    taxRate: 0.04, // 4%
  },
  {
    id: 15,
    grossIncomeMin: 12500001,
    grossIncomeMax: 13750000,
    taxRate: 0.05, // 5%
  },
  {
    id: 16,
    grossIncomeMin: 13750001,
    grossIncomeMax: 15100000,
    taxRate: 0.06, // 6%
  },
  {
    id: 17,
    grossIncomeMin: 15100001,
    grossIncomeMax: 16950000,
    taxRate: 0.07, // 7%
  },
  {
    id: 18,
    grossIncomeMin: 16950001,
    grossIncomeMax: 19750000,
    taxRate: 0.08, // 8%
  },
  {
    id: 19,
    grossIncomeMin: 19750001,
    grossIncomeMax: 24150000,
    taxRate: 0.09, // 9%
  },
  {
    id: 20,
    grossIncomeMin: 24150001,
    grossIncomeMax: 26450000,
    taxRate: 0.1, // 10%
  },
  {
    id: 21,
    grossIncomeMin: 26450001,
    grossIncomeMax: 28000000,
    taxRate: 0.11, // 11%
  },
  {
    id: 22,
    grossIncomeMin: 28000001,
    grossIncomeMax: 30050000,
    taxRate: 0.12, // 12%
  },
  {
    id: 23,
    grossIncomeMin: 30050001,
    grossIncomeMax: 32400000,
    taxRate: 0.13, // 13%
  },
  {
    id: 24,
    grossIncomeMin: 32400001,
    grossIncomeMax: 35400000,
    taxRate: 0.14, // 14%
  },
  {
    id: 25,
    grossIncomeMin: 35400001,
    grossIncomeMax: 39100000,
    taxRate: 0.15, // 15%
  },
  {
    id: 26,
    grossIncomeMin: 39100001,
    grossIncomeMax: 43850000,
    taxRate: 0.16, // 16%
  },
  {
    id: 27,
    grossIncomeMin: 43850001,
    grossIncomeMax: 47800000,
    taxRate: 0.17, // 17%
  },
  {
    id: 28,
    grossIncomeMin: 47800001,
    grossIncomeMax: 51400000,
    taxRate: 0.18, // 18%
  },
  {
    id: 29,
    grossIncomeMin: 51400001,
    grossIncomeMax: 56300000,
    taxRate: 0.19, // 19%
  },
  {
    id: 30,
    grossIncomeMin: 56300001,
    grossIncomeMax: 62200000,
    taxRate: 0.2, // 20%
  },
  {
    id: 31,
    grossIncomeMin: 62200001,
    grossIncomeMax: 68600000,
    taxRate: 0.21, // 21%
  },
  {
    id: 32,
    grossIncomeMin: 68600001,
    grossIncomeMax: 77500000,
    taxRate: 0.22, // 22%
  },
  {
    id: 33,
    grossIncomeMin: 77500001,
    grossIncomeMax: 89000000,
    taxRate: 0.23, // 23%
  },
  {
    id: 34,
    grossIncomeMin: 89000001,
    grossIncomeMax: 103000000,
    taxRate: 0.24, // 24%
  },
  {
    id: 35,
    grossIncomeMin: 103000001,
    grossIncomeMax: 125000000,
    taxRate: 0.25, // 25%
  },
  {
    id: 36,
    grossIncomeMin: 125000001,
    grossIncomeMax: 157000000,
    taxRate: 0.26, // 26%
  },
  {
    id: 37,
    grossIncomeMin: 157000001,
    grossIncomeMax: 206000000,
    taxRate: 0.27, // 27%
  },
  {
    id: 38,
    grossIncomeMin: 206000001,
    grossIncomeMax: 337000000,
    taxRate: 0.28, // 28%
  },
  {
    id: 39,
    grossIncomeMin: 337000001,
    grossIncomeMax: 454000000,
    taxRate: 0.29, // 29%
  },
  {
    id: 40,
    grossIncomeMin: 454000001,
    grossIncomeMax: 550000000,
    taxRate: 0.3, // 30%
  },
  {
    id: 41,
    grossIncomeMin: 550000001,
    grossIncomeMax: 695000000,
    taxRate: 0.31, // 31%
  },
  {
    id: 42,
    grossIncomeMin: 695000001,
    grossIncomeMax: 910000000,
    taxRate: 0.32, // 32%
  },
  {
    id: 43,
    grossIncomeMin: 910000001,
    grossIncomeMax: 1400000000,
    taxRate: 0.33, // 33%
  },
  {
    id: 44,
    grossIncomeMin: 1400000001,
    grossIncomeMax: null,
    taxRate: 0.34, // 34%
  },
];

export const TER_CATEGORY_B = [
  {
    id: 1,
    grossIncomeMin: 0,
    grossIncomeMax: 6200000,
    taxRate: 0, // 0%
  },
  {
    id: 2,
    grossIncomeMin: 6200001,
    grossIncomeMax: 6500000,
    taxRate: 0.0025, // 0.25%
  },
  {
    id: 3,
    grossIncomeMin: 6500001,
    grossIncomeMax: 6850000,
    taxRate: 0.005, // 0.5%
  },
  {
    id: 4,
    grossIncomeMin: 6850001,
    grossIncomeMax: 7300000,
    taxRate: 0.0075, // 0.75%
  },
  {
    id: 5,
    grossIncomeMin: 7300001,
    grossIncomeMax: 9200000,
    taxRate: 0.01, // 1%
  },
  {
    id: 6,
    grossIncomeMin: 9200001,
    grossIncomeMax: 10750000,
    taxRate: 0.015, // 1.5%
  },
  {
    id: 7,
    grossIncomeMin: 10750001,
    grossIncomeMax: 11250000,
    taxRate: 0.02, // 2%
  },
  {
    id: 8,
    grossIncomeMin: 11250001,
    grossIncomeMax: 11600000,
    taxRate: 0.025, // 2.5%
  },
  {
    id: 9,
    grossIncomeMin: 11600001,
    grossIncomeMax: 12600000,
    taxRate: 0.03, // 3%
  },
  {
    id: 10,
    grossIncomeMin: 12600001,
    grossIncomeMax: 13600000,
    taxRate: 0.04, // 4%
  },
  {
    id: 11,
    grossIncomeMin: 13600001,
    grossIncomeMax: 14950000,
    taxRate: 0.05, // 5%
  },
  {
    id: 12,
    grossIncomeMin: 14950001,
    grossIncomeMax: 16400000,
    taxRate: 0.06, // 6%
  },
  {
    id: 13,
    grossIncomeMin: 16400001,
    grossIncomeMax: 18450000,
    taxRate: 0.07, // 7%
  },
  {
    id: 14,
    grossIncomeMin: 18450001,
    grossIncomeMax: 21850000,
    taxRate: 0.08, // 8%
  },
  {
    id: 15,
    grossIncomeMin: 21850001,
    grossIncomeMax: 26000000,
    taxRate: 0.09, // 9%
  },
  {
    id: 16,
    grossIncomeMin: 26000001,
    grossIncomeMax: 27700000,
    taxRate: 0.1, // 10%
  },
  {
    id: 17,
    grossIncomeMin: 27700001,
    grossIncomeMax: 29350000,
    taxRate: 0.11, // 11%
  },
  {
    id: 18,
    grossIncomeMin: 29350001,
    grossIncomeMax: 31450000,
    taxRate: 0.12, // 12%
  },
  {
    id: 19,
    grossIncomeMin: 31450001,
    grossIncomeMax: 33950000,
    taxRate: 0.13, // 13%
  },
  {
    id: 20,
    grossIncomeMin: 33950001,
    grossIncomeMax: 37100000,
    taxRate: 0.14, // 14%
  },
  {
    id: 21,
    grossIncomeMin: 37100001,
    grossIncomeMax: 41100000,
    taxRate: 0.15, // 15%
  },
  {
    id: 22,
    grossIncomeMin: 41100001,
    grossIncomeMax: 45800000,
    taxRate: 0.16, // 16%
  },
  {
    id: 23,
    grossIncomeMin: 45800001,
    grossIncomeMax: 49500000,
    taxRate: 0.17, // 17%
  },
  {
    id: 24,
    grossIncomeMin: 49500001,
    grossIncomeMax: 53800000,
    taxRate: 0.18, // 18%
  },
  {
    id: 25,
    grossIncomeMin: 53800001,
    grossIncomeMax: 58500000,
    taxRate: 0.19, // 19%
  },
  {
    id: 26,
    grossIncomeMin: 58500001,
    grossIncomeMax: 64000000,
    taxRate: 0.2, // 20%
  },
  {
    id: 27,
    grossIncomeMin: 64000001,
    grossIncomeMax: 71000000,
    taxRate: 0.21, // 21%
  },
  {
    id: 28,
    grossIncomeMin: 71000001,
    grossIncomeMax: 80000000,
    taxRate: 0.22, // 22%
  },
  {
    id: 29,
    grossIncomeMin: 80000001,
    grossIncomeMax: 93000000,
    taxRate: 0.23, // 23%
  },
  {
    id: 30,
    grossIncomeMin: 93000001,
    grossIncomeMax: 109000000,
    taxRate: 0.24, // 24%
  },
  {
    id: 31,
    grossIncomeMin: 109000001,
    grossIncomeMax: 129000000,
    taxRate: 0.25, // 25%
  },
  {
    id: 32,
    grossIncomeMin: 129000001,
    grossIncomeMax: 163000000,
    taxRate: 0.26, // 26%
  },
  {
    id: 33,
    grossIncomeMin: 163000001,
    grossIncomeMax: 211000000,
    taxRate: 0.27, // 27%
  },
  {
    id: 34,
    grossIncomeMin: 211000001,
    grossIncomeMax: 374000000,
    taxRate: 0.28, // 28%
  },
  {
    id: 35,
    grossIncomeMin: 374000001,
    grossIncomeMax: 459000000,
    taxRate: 0.29, // 29%
  },
  {
    id: 36,
    grossIncomeMin: 459000001,
    grossIncomeMax: 555000000,
    taxRate: 0.3, // 30%
  },
  {
    id: 37,
    grossIncomeMin: 555000001,
    grossIncomeMax: 704000000,
    taxRate: 0.31, // 31%
  },
  {
    id: 38,
    grossIncomeMin: 704000001,
    grossIncomeMax: 957000000,
    taxRate: 0.32, // 32%
  },
  {
    id: 39,
    grossIncomeMin: 957000001,
    grossIncomeMax: 1405000000,
    taxRate: 0.33, // 33%
  },
  {
    id: 40,
    grossIncomeMin: 1405000001,
    grossIncomeMax: null,
    taxRate: 0.34, // 34%
  },
];

export const TER_CATEGORY_C = [
  {
    id: 1,
    grossIncomeMin: 0,
    grossIncomeMax: 6600000,
    taxRate: 0, // 0%
  },
  {
    id: 2,
    grossIncomeMin: 6600001,
    grossIncomeMax: 6950000,
    taxRate: 0.0025, // 0.25%
  },
  {
    id: 3,
    grossIncomeMin: 6950001,
    grossIncomeMax: 7350000,
    taxRate: 0.005, // 0.5%
  },
  {
    id: 4,
    grossIncomeMin: 7350001,
    grossIncomeMax: 7800000,
    taxRate: 0.0075, // 0.75%
  },
  {
    id: 5,
    grossIncomeMin: 7800001,
    grossIncomeMax: 8850000,
    taxRate: 0.01, // 1%
  },
  {
    id: 6,
    grossIncomeMin: 8850001,
    grossIncomeMax: 9800000,
    taxRate: 0.0125, // 1.25%
  },
  {
    id: 7,
    grossIncomeMin: 9800001,
    grossIncomeMax: 10950000,
    taxRate: 0.015, // 1.5%
  },
  {
    id: 8,
    grossIncomeMin: 10950001,
    grossIncomeMax: 11200000,
    taxRate: 0.0175, // 1.75%
  },
  {
    id: 9,
    grossIncomeMin: 11200001,
    grossIncomeMax: 12050000,
    taxRate: 0.02, // 2%
  },
  {
    id: 10,
    grossIncomeMin: 12050001,
    grossIncomeMax: 12950000,
    taxRate: 0.03, // 3%
  },
  {
    id: 11,
    grossIncomeMin: 12950001,
    grossIncomeMax: 14150000,
    taxRate: 0.04, // 4%
  },
  {
    id: 12,
    grossIncomeMin: 14150001,
    grossIncomeMax: 15550000,
    taxRate: 0.05, // 5%
  },
  {
    id: 13,
    grossIncomeMin: 15550001,
    grossIncomeMax: 17050000,
    taxRate: 0.06, // 6%
  },
  {
    id: 14,
    grossIncomeMin: 17050001,
    grossIncomeMax: 19500000,
    taxRate: 0.07, // 7%
  },
  {
    id: 15,
    grossIncomeMin: 19500001,
    grossIncomeMax: 22700000,
    taxRate: 0.08, // 8%
  },
  {
    id: 16,
    grossIncomeMin: 22700001,
    grossIncomeMax: 26600000,
    taxRate: 0.09, // 9%
  },
  {
    id: 17,
    grossIncomeMin: 26600001,
    grossIncomeMax: 28100000,
    taxRate: 0.1, // 10%
  },
  {
    id: 18,
    grossIncomeMin: 28100001,
    grossIncomeMax: 30100000,
    taxRate: 0.11, // 11%
  },
  {
    id: 19,
    grossIncomeMin: 30100001,
    grossIncomeMax: 32600000,
    taxRate: 0.12, // 12%
  },
  {
    id: 20,
    grossIncomeMin: 32600001,
    grossIncomeMax: 35400000,
    taxRate: 0.13, // 13%
  },
  {
    id: 21,
    grossIncomeMin: 35400001,
    grossIncomeMax: 38900000,
    taxRate: 0.14, // 14%
  },
  {
    id: 22,
    grossIncomeMin: 38900001,
    grossIncomeMax: 43000000,
    taxRate: 0.15, // 15%
  },
  {
    id: 23,
    grossIncomeMin: 43000001,
    grossIncomeMax: 47400000,
    taxRate: 0.16, // 16%
  },
  {
    id: 24,
    grossIncomeMin: 47400001,
    grossIncomeMax: 51200000,
    taxRate: 0.17, // 17%
  },
  {
    id: 25,
    grossIncomeMin: 51200001,
    grossIncomeMax: 55800000,
    taxRate: 0.18, // 18%
  },
  {
    id: 26,
    grossIncomeMin: 55800001,
    grossIncomeMax: 60400000,
    taxRate: 0.19, // 19%
  },
  {
    id: 27,
    grossIncomeMin: 60400001,
    grossIncomeMax: 66700000,
    taxRate: 0.2, // 20%
  },
  {
    id: 28,
    grossIncomeMin: 66700001,
    grossIncomeMax: 74500000,
    taxRate: 0.21, // 21%
  },
  {
    id: 29,
    grossIncomeMin: 74500001,
    grossIncomeMax: 83200000,
    taxRate: 0.22, // 22%
  },
  {
    id: 30,
    grossIncomeMin: 83200001,
    grossIncomeMax: 95000000,
    taxRate: 0.23, // 23%
  },
  {
    id: 31,
    grossIncomeMin: 95600001,
    grossIncomeMax: 110000000,
    taxRate: 0.24, // 24%
  },
  {
    id: 32,
    grossIncomeMin: 110000001,
    grossIncomeMax: 134000000,
    taxRate: 0.25, // 25%
  },
  {
    id: 33,
    grossIncomeMin: 134000001,
    grossIncomeMax: 169000000,
    taxRate: 0.26, // 26%
  },
  {
    id: 34,
    grossIncomeMin: 169000001,
    grossIncomeMax: 221000000,
    taxRate: 0.27, // 27%
  },
  {
    id: 35,
    grossIncomeMin: 221000001,
    grossIncomeMax: 390000000,
    taxRate: 0.28, // 28%
  },
  {
    id: 36,
    grossIncomeMin: 390000001,
    grossIncomeMax: 463000000,
    taxRate: 0.29, // 29%
  },
  {
    id: 37,
    grossIncomeMin: 463000001,
    grossIncomeMax: 561000000,
    taxRate: 0.3, // 30%
  },
  {
    id: 38,
    grossIncomeMin: 561000001,
    grossIncomeMax: 709000000,
    taxRate: 0.31, // 31%
  },
  {
    id: 39,
    grossIncomeMin: 709000001,
    grossIncomeMax: 965000000,
    taxRate: 0.32, // 32%
  },
  {
    id: 40,
    grossIncomeMin: 965000001,
    grossIncomeMax: 1419000000,
    taxRate: 0.33, // 33%
  },
  {
    id: 41,
    grossIncomeMin: 1419000001,
    grossIncomeMax: null,
    taxRate: 0.34, // 34%
  },
];

export const TER_CATEGORIES = {
  A: {
    name: "TER A",
    data: TER_CATEGORY_A,
  },
  B: {
    name: "TER B",
    data: TER_CATEGORY_B,
  },
  C: {
    name: "TER C",
    data: TER_CATEGORY_C,
  },
};

export const TER_DAILY = [
  { min: 0, max: 450000, rate: 0 },
  { min: 450001, max: 2500000, rate: 0.005 },
];

export const calculateTERHarian = (dailyGross) => {
  if (dailyGross <= 2500000) {
    const bracket = TER_DAILY.find(
      (b) => dailyGross >= b.min && dailyGross <= b.max,
    );
    return { type: "TER_DAILY", rate: bracket ? bracket.rate : 0 };
  }
  return { type: "PASAL_17_50", rate: null };
};

export const calculatePPh21NonPermanentDaily = (
  dailyGross,
  workingDays,
  marriageStatus = "TK",
  dependents = 0,
) => {
  const terDailyResult = calculateTERHarian(dailyGross);
  // No days worked means no wage was paid, so nothing is withheld. Defaulting
  // to one day used to bill a day of tax against a panel reading "0 hari".
  const days = workingDays > 0 ? workingDays : 0;
  const monthlyGross = dailyGross * days;

  if (terDailyResult.type === "TER_DAILY") {
    const dailyTax = dailyGross * terDailyResult.rate;
    const totalTax = dailyTax * days;

    return {
      method: "TER_DAILY",
      terRate: terDailyResult.rate,
      dailyGross,
      workingDays: days,
      monthlyGross,
      dailyTax,
      totalTax,
      ptkpDaily: 0,
      monthlyPtkp: 0,
      pkp: 0,
    };
  } else {
    const getPasal17Rate = (amount) => {
      for (const bracket of TAX_BRACKETS) {
        if (amount <= bracket.max) {
          return bracket.rate;
        }
      }
      return 0.35;
    };

    const calculateProgressiveTax = (amount) => {
      let tax = 0;
      let remaining = amount;
      let prevMax = 0;

      for (const bracket of TAX_BRACKETS) {
        const bracketSize = bracket.max - prevMax;
        const taxable = Math.min(remaining, bracketSize);
        if (taxable > 0) {
          tax += taxable * bracket.rate;
          remaining -= taxable;
        }
        prevMax = bracket.max;
        if (remaining <= 0) break;
      }
      return tax;
    };

    // PMK 168/2023 Pasal 12: the Pasal 17 tariff applies to the DPP, which is
    // 50% of the daily wage - not to the full wage with the result halved.
    // The two only agree while the DPP stays inside the 5% bracket.
    const dpp = dailyGross * 0.5;
    const pasal17Rate = getPasal17Rate(dpp);
    const progressiveTax = calculateProgressiveTax(dpp);

    const dailyTax = progressiveTax;
    const totalTax = dailyTax * days;

    return {
      method: "PASAL_17_50",
      terRate: null,
      pasal17Rate: pasal17Rate,
      dailyGross,
      workingDays: days,
      monthlyGross,
      dailyTax,
      totalTax,
      progressiveTax,
      dpp,
      ptkpDaily: 0,
      monthlyPtkp: 0,
      pkp: dpp,
    };
  }
};

export const PTKP_RATES = [
  {
    id: 1,
    code: "TK/0",
    amount: 54000000,
    monthlyAmount: 4500000,
  },
  {
    id: 2,
    code: "TK/1",
    amount: 58500000,
    monthlyAmount: 4875000,
  },
  {
    id: 3,
    code: "TK/2",
    amount: 63000000,
    monthlyAmount: 5250000,
  },
  {
    id: 4,
    code: "TK/3",
    amount: 67500000,
    monthlyAmount: 5625000,
  },
  {
    id: 5,
    code: "K/0",
    amount: 58500000,
    monthlyAmount: 4875000,
  },
  {
    id: 6,
    code: "K/1",
    amount: 63000000,
    monthlyAmount: 5250000,
  },
  {
    id: 7,
    code: "K/2",
    amount: 67500000,
    monthlyAmount: 5625000,
  },
  {
    id: 8,
    code: "K/3",
    amount: 72000000,
    monthlyAmount: 6000000,
  },
];

export const TAX_BRACKETS = [
  { max: 60000000, rate: 0.05, base: 0, excess: 0 },
  { max: 250000000, rate: 0.15, base: 3000000, excess: 60000000 },
  { max: 500000000, rate: 0.25, base: 31500000, excess: 250000000 },
  { max: 5000000000, rate: 0.3, base: 94000000, excess: 500000000 },
  { max: Infinity, rate: 0.35, base: 1444000000, excess: 5000000000 },
];

export const calculateProgressiveTax = (pkpAmount) => {
  let tax = 0;
  TAX_BRACKETS.forEach((bracket, index) => {
    const prevMax = index > 0 ? TAX_BRACKETS[index - 1].max : 0;
    const taxableAmount = Math.min(
      Math.max(0, pkpAmount - prevMax),
      bracket.max - prevMax,
    );
    if (taxableAmount > 0) tax += taxableAmount * bracket.rate;
  });
  return tax;
};

export const POSITION_COST_PERCENTAGE = 0.05;
export const POSITION_COST_MAX = 6000000;

// Pension cost for retired employees
export const PENSION_COST_PERCENTAGE = 0.05;
export const PENSION_COST_MAX = 2400000;

// PTKP and TER only recognise up to three dependants. The form stops at three,
// but a record from the API or another app can carry four or more, which used
// to match nothing and fall back to TK/0 - K/4 was taxed as category A on a
// Rp54,000,000 PTKP instead of category C on K/3's Rp72,000,000. A negative or
// missing count is no dependants at all.
const normalizeDependent = (dependent) =>
  Math.min(Math.max(Number(dependent) || 0, 0), 3);

export const getTERCategory = (marriageStatus, dependent) => {
  const dep = normalizeDependent(dependent);
  if (
    (marriageStatus === "TK" && dep === 1) ||
    (marriageStatus === "K" && dep === 0)
  ) {
    return "A";
  } else if (
    (marriageStatus === "TK" && (dep === 2 || dep === 3)) ||
    (marriageStatus === "K" && (dep === 1 || dep === 2))
  ) {
    return "B";
  } else if (marriageStatus === "K" && dep === 3) {
    return "C";
  }
  return "A";
};

export const calculateTERRate = (grossIncome, category) => {
  const terData = TER_CATEGORIES[category].data;

  const taxBracket = terData.find(
    (bracket) =>
      grossIncome >= bracket.grossIncomeMin &&
      (bracket.grossIncomeMax === null ||
        grossIncome <= bracket.grossIncomeMax),
  );

  if (taxBracket) return taxBracket.taxRate;

  // Category C leaves a hole between Rp95,000,000 and Rp95,600,001, so an
  // income landing in it matches no bracket. Returning 0 there would tax a
  // Rp95 million salary at nothing and, worse, make the gross-up fixed point
  // below cycle forever. Fall back to the last bracket the income clears; only
  // an income under the first bracket is genuinely untaxed.
  const lastCleared = terData
    .filter((bracket) => grossIncome >= bracket.grossIncomeMin)
    .pop();

  return lastCleared ? lastCleared.taxRate : 0;
};

export const calculateGrossSalary = (baseSalary, taxableAllowances) => {
  return baseSalary + taxableAllowances;
};

export const getPTKPRate = (marriageStatus, dependent) => {
  const code = `${marriageStatus}/${normalizeDependent(dependent)}`;
  return PTKP_RATES.find((rate) => rate.code === code) || PTKP_RATES[0];
};

// UU PPh Pasal 17 ayat (4): the taxable income the tariff is applied to is
// rounded down to full thousands of rupiah. The DJP 2024 handbook says the
// same for the last tax period of a Pegawai Tetap, whose DPP is "Penghasilan
// Kena Pajak dengan pembulatan ke bawah hingga ribuan rupiah penuh". Flooring
// is idempotent, so callers that already rounded lose nothing.
export const roundTaxableIncome = (taxableIncome) =>
  Math.floor(Math.max(0, taxableIncome) / 1000) * 1000;

export const calculateYearlyTax = (yearlyTaxableIncome) => {
  const taxableIncome = roundTaxableIncome(yearlyTaxableIncome);
  const bracket = TAX_BRACKETS.find((b) => taxableIncome <= b.max);
  return bracket.base + (taxableIncome - bracket.excess) * bracket.rate;
};

// WARNING: `max` in this table is a NET taxable-income bound (before the tax
// allowance is added), not the gross Article 17 bound used by TAX_BRACKETS
// above. Each cut-off is derived from PKP + T = the Article 17 bound. First
// bracket: x + x * 5/95 = 60,000,000 gives x = 57,000,000, and at that point
// T = 3,000,000, which is exactly the next bracket's `baseAdd`. So each
// bracket's `max` equals the following bracket's `excess`.
// Never copy figures across from TAX_BRACKETS.
export const TAX_BRACKETS_GROSS_UP = [
  {
    max: 57000000, // 60m gross
    rate: 0.05,
    baseAdd: 0,
    rateDiv: 95,
    rateMul: 5,
    excess: 0,
  },
  {
    max: 218500000, // 250m gross
    rate: 0.15,
    baseAdd: 3000000,
    rateDiv: 85,
    rateMul: 15,
    excess: 57000000, // 60m - 3m
  },
  {
    max: 406000000, // 500m gross
    rate: 0.25,
    baseAdd: 31500000,
    rateDiv: 75,
    rateMul: 25,
    excess: 218500000, // 250m - 31.5m
  },
  {
    max: 3556000000, // 5b gross
    rate: 0.3,
    baseAdd: 94000000,
    rateDiv: 70,
    rateMul: 30,
    excess: 406000000, // 500m - 94m
  },
  {
    max: Infinity,
    rate: 0.35,
    baseAdd: 1444000000,
    rateDiv: 65,
    rateMul: 35,
    excess: 3556000000, // 5b - 1.444b
  },
];

export const calculateYearlyTaxGrossUp = (yearlyTaxableIncome) => {
  const bracket = TAX_BRACKETS_GROSS_UP.find(
    (b) => yearlyTaxableIncome <= b.max,
  );

  if (!bracket) return 0;

  const tax =
    ((yearlyTaxableIncome - bracket.excess) * bracket.rateMul) /
      bracket.rateDiv +
    bracket.baseAdd;

  return Math.max(0, tax);
};

// Gross-up is a fixed point, not a two-step estimate: the rate used to gross
// the salary up has to be the rate the resulting gross actually falls into.
// Stopping one step short returns a gross whose own TER bracket is higher, so
// the tax withheld exceeds the allowance granted and the employee lands below
// the net they were promised. It also breaks the yearly reconciliation, since
// the last tax period solves the annual gross-up against an allowance that no
// longer equals the tax already withheld.
//
// TER is a step function, so the iteration is guarded against a cycle rather
// than assumed to converge. With the bracket-gap fallback above, no net across
// any of the three categories cycles; the guard is there so a future table
// edit cannot hang the calculator.
export const calculateGrossFromNet = (
  netSalary,
  taxableAllowances,
  terCategory,
) => {
  const net = calculateGrossSalary(netSalary, taxableAllowances);
  if (net <= 0) return 0;

  const tried = [];
  let rate = calculateTERRate(net, terCategory);

  while (!tried.includes(rate)) {
    tried.push(rate);
    const gross = net / (1 - rate);
    if (calculateTERRate(gross, terCategory) === rate) {
      return Math.max(0, gross);
    }
    rate = calculateTERRate(gross, terCategory);
  }

  // No rate is its own fixed point. Take the smallest gross that still delivers
  // the promised net, so the shortfall never lands on the employee.
  const covering = tried
    .map((tryRate) => net / (1 - tryRate))
    .filter(
      (gross) => gross - gross * calculateTERRate(gross, terCategory) >= net,
    )
    .sort((a, b) => a - b);

  return Math.max(0, covering[0] ?? net / (1 - Math.max(...tried)));
};

// The last tax period, and the only place these rules are written down.
//
// `yearlyGrossSalary` already includes this last period. Under gross-up that
// final month is still on a net basis, because its tax allowance is the
// unknown being solved for. `yearlyPositionCost` also already includes it.
//
// `yearlyTaxPaid` is the PPh 21 already withheld through TER. Under gross-up
// it is also the size of the tax allowance already folded into gross, so it
// is taken back out first. Otherwise that allowance is counted twice and T no
// longer equals the tax due on PKP + T.
//
// `annualise` follows PMK 168/2023 Appendix B. Example I.2.1.1 (an employee
// whose subjective tax liability existed from the start of the year but who
// only started work mid-year) is NOT annualized: that is the default and the
// majority of cases. Only example I.2.1.2 (the subjective tax liability
// itself beginning or ending mid-year) is annualized, and that annualization
// must be followed by prorating the tax back.
export const calculateLastTaxPeriod = ({
  yearlyGrossSalary,
  yearlyPositionCost,
  yearlyDeductions = 0,
  yearlyTaxPaid = 0,
  marriageStatus,
  dependent,
  isGrossUp = false,
  annualise = false,
  monthsWorked = 12,
  positionCostMax = POSITION_COST_MAX,
  lastPeriodGross = 0,
  positionCostMonthlyMax = POSITION_COST_MAX / 12,
}) => {
  const ptkp = getPTKPRate(marriageStatus, dependent);
  const months = Math.min(Math.max(monthsWorked, 1), 12);

  // Under gross-up the tax allowance solved for here is part of this period's
  // bruto, so it carries its own 5% position cost. The caller accumulated
  // `yearlyPositionCost` before the allowance was known, so the difference is
  // put back in. `lastPeriodGross` is this period's gross on a net basis, the
  // figure that cost was taken from. Callers that leave it at 0 are saying the
  // allowance does not move the position cost, and this returns the total
  // unchanged.
  const positionCostFor = (taxAllowance) => {
    if (!isGrossUp || lastPeriodGross <= 0 || taxAllowance <= 0) {
      return Math.min(yearlyPositionCost, positionCostMax);
    }
    const withoutAllowance = Math.min(
      lastPeriodGross * POSITION_COST_PERCENTAGE,
      positionCostMonthlyMax,
    );
    // Only `taxAllowance - yearlyTaxPaid` lands in this period's bruto. The
    // earlier months' allowances are already inside `yearlyGrossSalary`, and
    // their 5% already inside `yearlyPositionCost`, so charging the cost on the
    // whole year's tax counts them twice. Clamped at 0 because the last period
    // may be an overpayment.
    const lastPeriodBruto = Math.max(
      0,
      lastPeriodGross + taxAllowance - yearlyTaxPaid,
    );
    const withAllowance = Math.min(
      lastPeriodBruto * POSITION_COST_PERCENTAGE,
      positionCostMonthlyMax,
    );
    return Math.min(
      yearlyPositionCost - withoutAllowance + withAllowance,
      positionCostMax,
    );
  };

  const netIncomeFor = (taxAllowance) =>
    yearlyGrossSalary -
    (isGrossUp ? yearlyTaxPaid : 0) -
    positionCostFor(taxAllowance) -
    yearlyDeductions;

  // Annualize the net, apply Article 17, then prorate the tax back.
  const taxOn = (net) => {
    // Rounded here as well as inside calculateYearlyTax, so the taxable income
    // returned to callers is the DPP the tariff was actually applied to and
    // what a payslip shows reconciles with the tax it charges.
    const taxableIncome = roundTaxableIncome(
      (annualise ? (net * 12) / months : net) - ptkp.amount,
    );
    const fullYearTax = calculateYearlyTax(taxableIncome);
    return {
      taxableIncome,
      tax: annualise ? (fullYearTax * months) / 12 : fullYearTax,
    };
  };

  let yearlyTaxableIncome;
  let yearlyTax;

  if (isGrossUp) {
    // Solve T = tax(net(T) + T) by iteration rather than with the closed form
    // in TAX_BRACKETS_GROSS_UP. That closed form inverts Article 17 at
    // full-year scale on a fixed net, so it can express neither the proration
    // annualization needs nor the position cost the allowance itself
    // generates. Both maps here are monotonic and the composed slope is at
    // most the marginal rate (0.35) less the 5% the position cost gives back,
    // so the iteration is a contraction and converges geometrically. Forty
    // rounds is far past rupiah precision.
    let taxAllowance = 0;
    for (let i = 0; i < 40; i += 1) {
      const next = taxOn(netIncomeFor(taxAllowance) + taxAllowance).tax;
      const converged = Math.abs(next - taxAllowance) < 0.000001;
      taxAllowance = next;
      if (converged) break;
    }
    const solved = taxOn(netIncomeFor(taxAllowance) + taxAllowance);
    yearlyTaxableIncome = solved.taxableIncome;
    yearlyTax = solved.tax;
  } else {
    const plain = taxOn(netIncomeFor(0));
    yearlyTaxableIncome = plain.taxableIncome;
    yearlyTax = plain.tax;
  }

  return {
    yearlyTaxableIncome,
    yearlyTax,
    // May be negative: that is over-withholding to be refunded, exactly as in
    // example I.2.1.1 of the appendix.
    monthlyTax: yearlyTax - yearlyTaxPaid,
  };
};

// The last tax period under gross-up, expressed as a gross salary.
export const calculateGrossFromNetDecember = (
  netSalary,
  taxableAllowances,
  yearlyGrossSalary,
  yearlyPositionCost,
  yearlyDeductions,
  yearlyTaxPaid,
  marriageStatus,
  dependent,
  { annualise = false, monthsWorked = 12 } = {},
) => {
  const currentGross = calculateGrossSalary(netSalary, taxableAllowances);
  const monthlyPositionCost = Math.min(
    currentGross * POSITION_COST_PERCENTAGE,
    POSITION_COST_MAX / 12,
  );

  const { monthlyTax } = calculateLastTaxPeriod({
    yearlyGrossSalary,
    yearlyPositionCost: yearlyPositionCost + monthlyPositionCost,
    yearlyDeductions,
    yearlyTaxPaid,
    marriageStatus,
    dependent,
    isGrossUp: true,
    annualise,
    monthsWorked,
    lastPeriodGross: currentGross,
  });

  return Math.max(0, netSalary + monthlyTax + taxableAllowances);
};
